<template>
  <div class="admin">
    <loader v-if="checkingPermission" />
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  name: 'Admin',
  components: {
    Loader,
  },
  data() {
    return {
      checkingPermission: true,
    };
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  watch: {
    getUser() {
      this.checkPermission();
    },
  },
  created() {
    this.checkPermission();
  },
  methods: {
    checkPermission() {
      if (this.getUser && this.getUser.isAdmin) {
        this.checkingPermission = false;
      } else {
        this.$router.push({ name: 'Home' });
      }
    },
  },
};
</script>
